import { createSlice } from "@reduxjs/toolkit";

export const initialState: any = {
  ticketData: [],
  singleTicketData: [],
  ticketFeedbackSummary: {},
  ticketSuccessMsg: {
    message: "",
    id: "",
  },
  deleteErrorMsg: {
    message: "",
    id: "",
  },
  loading: true,
  pagination: {},

  ticketCategories: [],
  ticketCategoryLoading: false,
  ticketCategorySuccessMsg: {
    message: "",
    id: "",
  },
  ticketCategoryErrorMsg: {
    message: "",
    id: "",
  },
  lastCreatedCategoryId: null,
};

const ticketSlice = createSlice({
  name: "ticket",
  initialState,
  reducers: {
    fetchSingleTicketData(state, action) {
      state.singleTicketData = action.payload.data;
    },
    fetchTicketData(state, action) {
      state.ticketData = action.payload.data;
    },
    setPagination(state, action) {
      state.pagination = action.payload;
    },
    ticketSuccessMsg(state, action) {
      state.ticketSuccessMsg.message = action.payload.message;
      state.ticketSuccessMsg.id = action.payload.id;
    },
    ticketErrorMsg(state, action) {
      state.deleteErrorMsg = action.payload;
    },
    setTicketLoader(state, action) {
      state.loading = action.payload;
    },
    setTicketFeedbackSummary(state, action) {
      state.ticketFeedbackSummary = action.payload;
    },

    setTicketCategories(state, action) {
      state.ticketCategories = action.payload;
    },
    setTicketCategoryLoader(state, action) {
      state.ticketCategoryLoading = action.payload;
    },
    ticketCategorySuccess(state, action) {
      state.ticketCategorySuccessMsg.message = action.payload.message;
      state.ticketCategorySuccessMsg.id = action.payload.id;
    },
    ticketCategoryError(state, action) {
      state.ticketCategoryErrorMsg.message = action.payload.message;
      state.ticketCategoryErrorMsg.id = action.payload.id;
    },
    setLastCreatedCategoryId(state, action) {
      state.lastCreatedCategoryId = action.payload;
    },
  },
});

export const {
  // Tickets
  fetchSingleTicketData,
  fetchTicketData,
  setPagination,
  setTicketLoader,
  ticketSuccessMsg,
  ticketErrorMsg,
  setTicketFeedbackSummary,

  // Ticket Category
  setTicketCategories,
  setTicketCategoryLoader,
  ticketCategorySuccess,
  ticketCategoryError,
  setLastCreatedCategoryId,
} = ticketSlice.actions;

export default ticketSlice.reducer;
